export function init() {
  const btnRemoveItem = document.querySelectorAll('.btn-remove-wishlist');

  btnRemoveItem.forEach((button, index) => {
    button.addEventListener('click', () => {
      const productId = $(`.product-${index}`).val();

      axios.delete('/remove-item-to-wishlist', {
        data: {
          product_id: productId,
        }
      })
        .then((response) => {
          const wishlistItem = $(`#wishlist-${index}`);
          const wishlistTotal = $('.wishlist-total');
          wishlistItem.remove();
          if (response.data.totalItem <= 0) {
            const wishlistEle = $('.wishlist');
            const notfound = `
            <div class="d-flex flex-column align-items-center justify-content-center py-5">
              <img width="35%" src="${window.location.origin}/assets/images/notfound-wishlist.jpg" alt="Không có sản phẩm nào được thêm vào yêu thích.">
              <h4 class="font-nunito font-weight-bold">Không tìm thấy sản phẩm nào</h4>
            </div>
          `;
            wishlistEle.html(notfound);
          }
          wishlistTotal.html(response.data.totalItem);
          toastr["success"](response.data.message);
        })
        .catch(error => {
          toastr["info"](error.message);
        });
    });
  });
}
